import GeoJSON from "ol/format/GeoJSON";
import OlStyle from "ol/style/Style";
import { Stroke } from "ol/style";
import Style from "ol/style/Style";
import VectorTileLayer from "ol/layer/VectorTile";
import VectorTileSource from "ol/source/VectorTile";
import { transformGeoJSON } from "../../layer/utils";
export class LidarLayer {
    constructor(navigator, map, routeconfigs, olstyle, olstyle_area) {
        this._layers = [];
        this._fragmentsLayer = null;
        this._map = null;
        this._navigator = null;
        this._selected_features = [];
        this._highlighted_feature_uid = null;
        this._selectionLayer = null;
        this._selection_changes_callback = null;
        this._highlighted_changes_callback = null;
        this._map = map;
        this._navigator = navigator;
        this.init(routeconfigs, olstyle, olstyle_area);
        const sel_cbf = (action, f) => {
            if (this._selection_changes_callback) {
                this._selection_changes_callback({
                    [action]: {
                        uid: f?.getProperties().uid,
                        campaign_name: f?.getProperties().campaign_name,
                        start_timestamp: f?.getProperties().start_timestamp,
                    },
                    selection: this._selected_features,
                });
            }
        };
        this._add_interactions((af) => sel_cbf("added", af), (rf) => sel_cbf("removed", rf), (hf) => {
            if (this._highlighted_changes_callback) {
                if (!hf)
                    return this._highlighted_changes_callback(null);
                this._highlighted_changes_callback({
                    uid: hf.getProperties().uid,
                    campaign_name: hf.getProperties().campaign_name,
                    start_timestamp: hf.getProperties().start_timestamp,
                });
            }
        });
    }
    get layers() {
        return this._layers;
    }
    init(routeconfigs, olstyle, olstyle_area) {
        // overwrite routeconfigs from the property, until we have a better solution
        routeconfigs = [
            {
                type: "route_lines",
                loa: 1,
                min_zoom: 13,
                max_zoom: 17,
            },
            {
                type: "route_hexes",
                loa: 0,
                min_zoom: 11,
                max_zoom: 13,
            },
            {
                type: "route_hexes",
                loa: 1,
                min_zoom: 9,
                max_zoom: 11,
            },
            {
                type: "route_hexes",
                loa: 2,
                min_zoom: 0,
                max_zoom: 9,
            },
        ];
        for (const routeconfig of routeconfigs) {
            let style = olstyle;
            let loaderf;
            if (routeconfig.type == "route_hexes")
                style = olstyle_area;
            const layer = new VectorTileLayer({
                renderMode: "vector",
                source: new VectorTileSource({
                    format: new GeoJSON(),
                    tileSize: 512,
                    overlaps: false,
                    cacheSize: 8,
                    tileLoadFunction: (tile, url) => {
                        tile.setLoader((extent, resolution, projection) => {
                            if (this._map.getView().getZoom() <= routeconfig.min_zoom ||
                                this._map.getView().getZoom() > routeconfig.max_zoom) {
                                tile.setFeatures([]);
                                return;
                            }
                            const srid = parseInt(projection.getCode().split(":").slice(-1)[0]);
                            switch (routeconfig.type) {
                                case "route_lines":
                                    loaderf = this._navigator.api.data.getLidarFragmentLines({
                                        loa: routeconfig.loa,
                                        minEasting: extent[0],
                                        maxEasting: extent[2],
                                        minNorthing: extent[1],
                                        maxNorthing: extent[3],
                                        epsg: srid,
                                    });
                                    break;
                                case "route_hexes":
                                    loaderf = this._navigator.api.data.getLidarFragmentHexes({
                                        loa: routeconfig.loa,
                                        minEasting: extent[0],
                                        maxEasting: extent[2],
                                        minNorthing: extent[1],
                                        maxNorthing: extent[3],
                                        epsg: srid,
                                    });
                                    break;
                            }
                            loaderf
                                .then((geojson) => {
                                const geojson_transform = transformGeoJSON(geojson, 4326, srid);
                                const features = new GeoJSON().readFeatures(geojson_transform);
                                tile.setFeatures(features);
                            })
                                .catch((error) => {
                                tile.setFeatures([]);
                                console.warn(error);
                            });
                        });
                    },
                    url: "{z}/{x}/{y}",
                }),
                zIndex: 200,
                minZoom: routeconfig.min_zoom,
                maxZoom: routeconfig.max_zoom,
                style: style,
            });
            this._layers.push(layer);
            this._select_style = new OlStyle({
                stroke: new Stroke({
                    color: "rgba(204, 102, 51,1.0)",
                    width: 5.0,
                }),
                zIndex: 200,
            });
            this._highlight_style = new OlStyle({
                stroke: new Stroke({
                    color: "rgba(204, 102, 51,1.0)",
                    width: 8.0,
                }),
                zIndex: 210,
            });
        }
        let style = olstyle;
        let loaderf;
        this._fragmentsLayer = new VectorTileLayer({
            renderMode: "vector",
            source: new VectorTileSource({
                format: new GeoJSON(),
                tileSize: 512,
                overlaps: false,
                cacheSize: 8,
                tileLoadFunction: (tile, url) => {
                    tile.setLoader((extent, resolution, projection) => {
                        if (this._map.getView().getZoom() <= 17 || this._map.getView().getZoom() > 100) {
                            tile.setFeatures([]);
                            return;
                        }
                        const srid = parseInt(projection.getCode().split(":").slice(-1)[0]);
                        loaderf = this._navigator.api.data.getLidarFragments({
                            minEasting: extent[0],
                            maxEasting: extent[2],
                            minNorthing: extent[1],
                            maxNorthing: extent[3],
                            epsg: srid,
                        });
                        loaderf
                            .then((geojson) => {
                            const geojson_transform = transformGeoJSON(geojson, 4326, srid);
                            const features = new GeoJSON().readFeatures(geojson_transform);
                            tile.setFeatures(features);
                        })
                            .catch((error) => {
                            tile.setFeatures([]);
                            console.warn(error);
                        });
                    });
                },
                url: "{z}/{x}/{y}",
            }),
            zIndex: 200,
            minZoom: 17,
            maxZoom: 100,
            style: style,
        });
        this._add_selection_layer();
    }
    _change_mouse_cursor(cursor) {
        const mapElement = document.getElementById("map");
        if (mapElement) {
            mapElement.style.cursor = cursor;
        }
    }
    _add_selection_layer() {
        this._selectionLayer = new VectorTileLayer({
            renderMode: "vector",
            source: this._fragmentsLayer.getSource(),
            style: (feature) => {
                if (!feature)
                    return new Style();
                if (!feature.getProperties())
                    return new Style();
                if (feature.getProperties().uid == this._highlighted_feature_uid) {
                    return this._highlight_style;
                }
                const matches = this._selected_features.filter((sel_f) => feature.getProperties().uid == sel_f.uid);
                if (matches.length > 0) {
                    return this._select_style;
                }
                return new Style();
            },
            zIndex: 210,
        });
    }
    _add_interactions(add_callback, remove_callback, highlight_callback) {
        this._map.on("pointermove", (evt) => {
            if (!this._fragmentsLayer.getVisible())
                return;
            const isLayerExistsInMap = this._map.getLayers().getArray().includes(this._fragmentsLayer);
            if (!isLayerExistsInMap)
                return;
            this._fragmentsLayer.getFeatures(evt.pixel).then((features) => {
                if (features.length === 0) {
                    this._change_mouse_cursor("default");
                    this._highlighted_feature_uid = null;
                    highlight_callback(null);
                    this._selectionLayer.changed();
                    return;
                }
                const feature = features[0];
                if (!feature) {
                    this._change_mouse_cursor("default");
                    return;
                }
                this._change_mouse_cursor("pointer");
                this._highlighted_feature_uid = feature.getProperties().uid;
                highlight_callback(feature);
                this._selectionLayer.changed();
            });
        });
        this._map.on("singleclick", (evt) => {
            if (!this._fragmentsLayer.getVisible())
                return;
            const originalEvent = evt.originalEvent;
            let isTouch = false;
            if (originalEvent instanceof PointerEvent) {
                isTouch = originalEvent.pointerType === "touch";
            }
            const hitTolerance = isTouch ? 20 : 5;
            const features = this._map.getFeaturesAtPixel(evt.pixel, {
                hitTolerance: hitTolerance,
                layerFilter: (layer) => layer === this._fragmentsLayer,
            });
            if (!features.length) {
                return;
            }
            const highlight_feature = features[0];
            const uid = highlight_feature.getProperties().uid;
            const existingIndex = this._selected_features.findIndex((f) => f.uid === uid);
            if (existingIndex !== -1) {
                // remove from selection
                this._selected_features.splice(existingIndex, 1);
                remove_callback?.(highlight_feature);
            }
            else {
                // add to selection
                this._selected_features.push({
                    uid,
                    campaign_name: highlight_feature.getProperties().campaign_name,
                    start_timestamp: highlight_feature.getProperties().start_timestamp,
                });
                add_callback?.(highlight_feature);
            }
            this._selectionLayer.changed();
            this._fragmentsLayer.changed();
        });
    }
    activate(selections_changed, highlighted, selectioncolor = [204, 102, 51, 1.0], highlightcolor = [204, 102, 51, 1.0]) {
        this._layers.forEach((layer) => {
            this._map.addLayer(layer);
        });
        this._map.addLayer(this._fragmentsLayer);
        this._map.addLayer(this._selectionLayer);
        if (selections_changed)
            this._selection_changes_callback = selections_changed;
        if (highlighted)
            this._highlighted_changes_callback = highlighted;
        this._select_style.getStroke().setColor(`rgba(${selectioncolor.join(",")})`);
        this._highlight_style.getStroke().setColor(`rgba(${highlightcolor.join(",")})`);
    }
    deactivate() {
        this._change_mouse_cursor("default");
        this._layers.forEach((layer) => {
            this._map.removeLayer(layer);
        });
        this._map.removeLayer(this._fragmentsLayer);
        this._map.removeLayer(this._selectionLayer);
        this._selection_changes_callback = null;
    }
    remove_from_selection(uid) {
        const selIndex = this._selected_features.map((x) => x.uid).indexOf(uid);
        this._selected_features.splice(selIndex, 1);
        this._selectionLayer.changed();
    }
    clear_selection() {
        this._selected_features = [];
        this._highlighted_feature_uid = null;
        this._selectionLayer.changed();
    }
    highlight_feature(uid) {
        this._highlighted_feature_uid = uid;
        this._selectionLayer.changed();
    }
}
//# sourceMappingURL=LidarLayer.js.map